module.exports = __webpack_public_path__ + "static/media/logo.2c33e869.svg";